import { FieldError } from 'react-hook-form';

// A recursive JSON-like structure whose leaves are all `Leaf`
export type Error =
  | FieldError // a leaf
  | { [key: string]: Error } // an object whose values are subtrees
  | Error[]; // an array of subtrees

export const walkLeaves = (
  tree: Error,
  onLeaf: (leaf: FieldError, path: (string | number)[]) => void,
  path: (string | number)[] = [],
): void => {
  if (isLeaf(tree)) {
    onLeaf(tree, path);
    return;
  }

  if (Array.isArray(tree)) {
    tree.forEach((item, i) => walkLeaves(item, onLeaf, [...path, i]));
  } else {
    Object.entries(tree).forEach(([key, value]) =>
      walkLeaves(value, onLeaf, [...path, key]),
    );
  }
};

const isLeaf = (value: any): value is FieldError => {
  return (
    value &&
    typeof value === 'object' &&
    'message' in value &&
    'type' in value &&
    'ref' in value
  );
};

export const handleLocationError =
  (enqueueSnackbar: any, t: any) => (e: Error) => {
    walkLeaves(e, (leaf, path) => {
      if (!leaf.ref) {
        console.log('Validation error:', leaf.message, path.join('.'));
        enqueueSnackbar(
          t('page.locations.errors.unhandledFormError', {
            errorDetails: `${path.join('.')}: ${leaf.message}`,
          }),
          { severity: 'error' },
        );
      }
    });
  };
